import React, { useState } from 'react';
import Header from '../components/shared/Header';
import SearchField from './shared/SearchField';
import MapComponent from './MapComponent';
import { useApp } from '../context/appContext';
import '../styles/global.css';
import '../styles/MapScreen.css';

const steps = [
  { name: 'Select the location', link: 'map', isActive: true },
  { name: 'Appointment Details', link: 'date-picker', isActive: false },
  { name: 'Confirm Details', link: 'confirmation', isActive: false }
];

const MapScreen = () => {
  const [selectedLocation, setSelectedLocation] = useState(null);

  const { setCurrentPage } = useApp()

  const handlePlaceSelected = (place) => {
    setSelectedLocation({
      location: place.location,
      lat: place.lat,
      lng: place.lng
    });
    setCurrentPage('listing');
  };

  return (
    <div className="main-container">
      <Header
        title="Book an Eye Test"
        steps={steps}
        subheading="SELECT THE LOCATION"
        pageinfo="Search for your nearest Optical Superstore location"
        setCurrentPage={setCurrentPage}
      />
      <div className="sub-container">
        <SearchField onPlaceSelected={handlePlaceSelected} />
        <MapComponent location={selectedLocation} />
      </div>
    </div>
  );
};

export default MapScreen;